/** Path API relativo all'origin in produzione, per mercato (`REACT_APP_MARKET`). */
const MARKET_API_PATH = {
  tj: '/api',
  fm: '/adams-api/api'
}

const DEFAULT_DEV_API_BASE_URL = 'http://www.ilpdevelopment.com:3034/api'

/**
 * Base URL API ADaMS (senza trailing slash).
 * - Dev: `REACT_APP_API_BASE_URL` da `.env.development` / `.env.local`
 * - Prod: stesso host della pagina + path in base a `REACT_APP_MARKET`
 */
function resolveApiBaseUrl () {
  const override = process.env.REACT_APP_API_BASE_URL
  if (override) {
    return override.replace(/\/$/, '')
  }

  if (process.env.NODE_ENV === 'production') {
    const market = process.env.REACT_APP_MARKET || 'tj'
    const path = MARKET_API_PATH[market] || MARKET_API_PATH.tj
    // eslint-disable-next-line no-restricted-globals
    return new URL(path, window.location.origin).href.replace(/\/$/, '')
  }

  return DEFAULT_DEV_API_BASE_URL
}

export const NewApiBaseUrl = resolveApiBaseUrl()
